<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <article>
        <h2>회원가입</h2>
        <ul class="breadCrumb">
          <li class="home"></li>
          <li>
            <p class="pageTxt">회원가입(사업자)</p>
            <ul class="depth">
              <li><router-link to="/membershipagreement" title="회원가입(일반)">회원가입(일반)</router-link></li>
              <li><router-link to="/businessagreement" title="회원가입(사업자)">회원가입(사업자)</router-link></li>
            </ul>
          </li>
        </ul>
      </article>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <!--stepArea-->
        <div class="stepArea type02">
          <ul>
            <li>
              <span>1</span>
              <p>이용약관 확인 및 동의</p>
            </li>
            <li class="on">
              <span>2</span>
              <p>정보입력</p>
            </li>
            <li>
              <span>3</span>
              <p>회원가입 신청완료</p>
            </li>
          </ul>
        </div>
        <!--//stepArea-->

        <!--table pc-->
        <div class="table horizontal-table web">
          <table>
            <caption>
              회원가입 정보입력 테이블
            </caption>
            <colgroup>
              <col style="width: 15%" />
              <col style="width: 35%" />
              <col style="width: 15%" />
              <col style="width: auto" />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">아이디<span class="redDot">*</span></th>
                <td>
                  <div class="flex">
                    <input
                      type="text"
                      title="아이디 입력"
                      @keyup.enter="OverlapBtn"
                      placeholder="영문,숫자 조합 4~20자리"
                      v-model="empNo"
                      @input="resetUsedCnt"
                      maxlength="20"
                    />
                    <button type="button" class="btn gray" @click="OverlapBtn">중복확인</button>
                  </div>
                  <p v-if="usedCnt === 1" class="reference orange">중복된 아이디입니다.</p>
                  <p v-if="usedCnt === 0" class="reference orange">사용 가능한 아이디입니다.</p>
                  <p v-if="usedCnt === -2" class="reference orange">
                    조건에 맞지 않습니다. ※4~20자의 영문, 숫자만 사용 가능합니다.
                  </p>
                  <div class="error" v-if="empNorequired">필수 입력란입니다.</div>
                  <div class="error" v-if="empNoidRegex">
                    조건에 맞지 않습니다. ※4~20자의 영문, 숫자만 사용 가능합니다.
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">비밀번호<span class="redDot">*</span></th>
                <td>
                  <input
                    type="password"
                    title="비밀번호 입력"
                    placeholder="영문,숫자,특수문자 조합 8-20자리"
                    v-model="password"
                  />
                  <div class="error" v-if="passwordrequired">필수 입력란입니다.</div>
                  <div class="error" v-if="passwordminLength">8~20자리 입력란입니다.</div>
                  <div class="error" v-if="passwordmaxLength">8~20자리 입력란입니다.</div>
                  <div class="error" v-if="passwordpassRegex">
                    조건에 맞지 않습니다.<br />※ 숫자,영문자,특수문자(!,@,#,$,%,&,*,? 만 사용 가능합니다.)
                  </div>
                </td>
                <th scope="row">비밀번호 확인<span class="redDot">*</span></th>
                <td>
                  <input type="password" title="비밀번호 재입력" v-model="passwordCon" />
                  <div class="error" v-if="passwordConrequired">필수 입력란입니다.</div>
                  <div class="error" v-if="passwordConsameAsPassword">일치하지 않는 비밀번호입니다.</div>
                </td>
              </tr>
              <tr>
                <th scope="row">법인(단체)명<span class="redDot">*</span></th>
                <td>
                  <input type="text" title="법인(단체)명 입력" v-model="companyNm" />
                  <div class="error" v-if="companyNmrequired">필수 입력란입니다.</div>
                </td>
                <th scope="row">대표자명<span class="redDot">*</span></th>
                <td>
                  <input type="text" title="대표자명 입력" v-model="CEONm" />
                  <div class="error" v-if="CEONmrequired">필수 입력란입니다.</div>
                </td>
              </tr>
              <tr>
                <th scope="row">사업자등록번호<span class="redDot">*</span></th>
                <td>
                  <div>
                    <input type="text" title="사업자등록번호 입력" v-model="companyNumber" oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"/>
                    <div class="error" v-if="companyNumberrequired">필수 입력란입니다.</div>
                  </div>
                </td>
                <th scope="row">개업일자<span class="redDot">*</span></th>
                <td>
                <v-col class="calendar">
                    <v-menu ref="menu2" :close-on-content-click="false"
                        :return-value.sync="openDt" transition="scale-transition"  offset-y min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="openDt" :value="openDt" readonly v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker locale="ko-KR" v-model="openDt" no-title scrollable>
                          <v-btn text color="primary" @click="$refs.menu2.save(openDt)">확인</v-btn>
                        </v-date-picker>
                    </v-menu>
                    
                </v-col>
                  <span class="error" v-if="openDtrequired">필수 입력란입니다.</span>
                </td>
              </tr>
              <tr>
                <th scope="row">사업자 휴대폰번호<span class="redDot">*</span></th>
                <td>
                  <div class="tell">
                    <input
                      type="text"
                      maxlength="3"
                      title="사업자 휴대폰 식별번호 선택"
                      v-model="firstNumber"
                      oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"
                    />
                    <input
                      type="text"
                      maxlength="4"
                      title="휴대폰 앞 4자리 입력"
                      v-model="secondNumber"
                      oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"
                    />
                    <input
                      type="text"
                      maxlength="4"
                      title="휴대폰 뒤 4자리 입력"
                      v-model="lastNumber"
                      oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"
                    />
                  </div>
                  <div class="error" v-if="firstNumberrequired || secondNumberrequired || lastNumberrequired">
                    필수 입력란입니다.
                  </div>
                </td>
                <th scope="row">사업자 전화번호<span class="redDot">*</span></th>
                <td>
                  <div class="tell">
                    <input
                      type="text"
                      maxlength="3"
                      title="사업자 전화 식별번호 선택"
                      v-model="firstTelnumber"
                      oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"
                    />
                    <input
                      type="text"
                      maxlength="4"
                      title="전화번호 앞 4자리 입력"
                      v-model="secondTelnumber"
                      oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"
                    />
                    <input
                      type="text"
                      maxlength="4"
                      title="전화번호 뒤 4자리 입력"
                      v-model="lastTelnumber"
                      oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"
                    />
                  </div>
                  <div class="error" v-if="firstTelnumberrequired || secondTelnumberrequired || lastTelnumberrequired">
                    필수 입력란입니다.
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">사업자주소<span class="redDot">*</span></th>
                <td colspan="3">
                  <div class="address">
                    <div class="flex">
                      <input type="text" title="우편번호 입력" v-model="zipcode" readonly />
                      <button type="button" class="btn gray" @click="daumPostcodeBtn">우편번호</button>
                    </div>
                    <div class="flex">
                      <input type="text" title="주소 입력" v-model="addr" readonly />
                      <input type="text" title="상세주소 입력" v-model="addrDetail" />
                    </div>
                    <div class="error" v-if="addrrequired">필수 입력란입니다.</div>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">웹 선불권 신청주차장<span class="redDot">*</span></th>
                <td>
                  <select class="middle" v-model="sectnId">
                    <option :key="i" :value="parking.SECTN_ID" v-for="(parking, i) in parkingList">
                      {{ parking.PARKING_NM }}
                    </option>
                  </select>
                  <div class="error" v-if="sectnIdrequired">필수 입력란입니다.</div>
                </td>
                <div v-if="isNamcheon">
                  <th scope="row">무료 웹 선불권 서비스</th>
                  <td>
                    <div class="radioGroup">
                      <p class="radio">
                        <input type="radio" id="radio-01" name="radio" class="hidden" />
                        <label for="radio-01">사용함</label>
                      </p>
                      <p class="radio">
                        <input type="radio" id="radio-02" name="radio" class="hidden" />
                        <label for="radio-02">미사용</label>
                      </p>
                    </div>
                  </td>
                </div>
              </tr>
              <tr>
                <th scope="row">사업자등록증<span class="redDot">*</span></th>
                <td>
                  <div class="flex fileArea">
                    <p class="upload-name">{{ firstName }}</p>
                    <input type="file" class="hidden" id="file" ref="files" @change="changeFile" @click="resetFile" />
                    <label for="file" class="btn gray">파일첨부</label>
                  </div>
                  <p class="info">첨부파일 (최대용량:20M) *이미지 파일 (jpg, jpeg, gif, png, pdf)</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--//table pc-->

        <!--table mobile-->
        <div class="table horizontal-table mobile">
          <table>
            <caption>
              회원가입 정보입력 테이블
            </caption>
            <colgroup>
              <col style="width: 35%" />
              <col style="width: 65%" />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">아이디<span class="redDot">*</span></th>
                <td>
                  <div class="flex">
                    <input
                      type="text"
                      title="아이디 입력"
                      @keyup.enter="OverlapBtn"
                      placeholder="영문,숫자,특수문자 조합 4~20자리"
                      v-model="empNo"
                      @input="resetUsedCnt"
                      maxlength="20"
                    />
                    <button type="button" class="btn gray" @click="OverlapBtn">중복확인</button>
                  </div>
                  <p v-if="usedCnt === 1" class="reference orange">중복된 아이디입니다.</p>
                  <p v-if="usedCnt === 0" class="reference orange">사용 가능한 아이디입니다.</p>
                  <div class="error" v-if="empNorequired">필수 입력란입니다.</div>
                  <div class="error" v-if="empNoidRegex">
                    조건에 맞지 않습니다. ※4~20자의 영문, 숫자만 사용 가능합니다.
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">비밀번호<span class="redDot">*</span></th>
                <td>
                  <input
                    type="password"
                    title="비밀번호 입력"
                    placeholder="영문,숫자,특수문자 조합 8-20자리"
                    v-model="password"
                  />
                  <div class="error" v-if="passwordrequired">필수 입력란입니다.</div>
                  <div class="error" v-if="passwordminLength">8~20자리 입력란입니다.</div>
                  <div class="error" v-if="passwordmaxLength">8~20자리 입력란입니다.</div>
                  <div class="error" v-if="passwordpassRegex">
                    조건에 맞지 않습니다.<br />※ 숫자,영문자,특수문자(!,@,#,$,%,&,*,? 만 사용 가능합니다.)
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">비밀번호 확인<span class="redDot">*</span></th>
                <td>
                  <input type="password" title="비밀번호 재입력" v-model="passwordCon" />
                  <div class="error" v-if="passwordConrequired">필수 입력란입니다.</div>
                  <div class="error" v-if="passwordConsameAsPassword">일치하지 않는 비밀번호입니다.</div>
                </td>
              </tr>
              <tr>
                <th scope="row">법인(단체)명<span class="redDot">*</span></th>
                <td>
                  <input type="text" title="법인(단체)명 입력" v-model="companyNm" />
                  <div class="error" v-if="companyNmrequired">필수 입력란입니다.</div>
                </td>
              </tr>
              <tr>
                <th scope="row">대표자명<span class="redDot">*</span></th>
                <td>
                  <input type="text" title="대표자명 입력" v-model="CEONm" />
                  <div class="error" v-if="CEONmrequired">필수 입력란입니다.</div>
                </td>
              </tr>
              <tr>
                <th scope="row">사업자등록번호<span class="redDot">*</span></th>
                <td>
                  <div>
                    <input type="text" title="사업자등록번호 입력" v-model="companyNumber" oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"/>
                    <div class="error" v-if="companyNumberrequired">필수 입력란입니다.</div>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">개업일자<span class="redDot">*</span></th>
                <td>
                  <v-col class="calendar">
                    <v-menu ref="menu1" :close-on-content-click="false"
                        :return-value.sync="openDt" transition="scale-transition"  offset-y min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="openDt" :value="openDt" readonly v-bind="attrs" v-on="on"></v-text-field>
                        </template>
                        <v-date-picker locale="ko-KR" v-model="openDt" no-title scrollable>
                          <v-btn text color="primary" @click="$refs.menu1.save(openDt)">확인</v-btn>
                        </v-date-picker>
                    </v-menu>
                    
                </v-col>
                  <span class="error" v-if="openDtrequired">필수 입력란입니다.</span>
                </td>
              </tr>
              <tr>
                <th scope="row">사업자 휴대폰번호<span class="redDot">*</span></th>
                <td>
                  <div class="tell">
                    <input
                      type="text"
                      maxlength="3"
                      title="사업자 휴대폰 식별번호 선택"
                      v-model="firstNumber"
                      oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"
                    />
                    <input
                      type="text"
                      maxlength="4"
                      title="휴대폰 앞 4자리 입력"
                      v-model="secondNumber"
                      oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"
                    />
                    <input
                      type="text"
                      maxlength="4"
                      title="휴대폰 뒤 4자리 입력"
                      v-model="lastNumber"
                      oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"
                    />
                  </div>
                  <div class="error" v-if="firstNumberrequired || secondNumberrequired || lastNumberrequired">
                    필수 입력란입니다.
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">사업자 전화번호</th>
                <td>
                  <div class="tell">
                    <input
                      type="text"
                      maxlength="3"
                      title="사업자 전화 식별번호 선택"
                      v-model="firstTelnumber"
                      oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"
                    />
                    <input
                      type="text"
                      maxlength="4"
                      title="전화번호 앞 4자리 입력"
                      v-model="secondTelnumber"
                      oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"
                    />
                    <input
                      type="text"
                      maxlength="4"
                      title="전화번호 뒤 4자리 입력"
                      v-model="lastTelnumber"
                      oninput="javascript: this.value = this.value.replace(/[^0-9]/g, '');"
                    />
                  </div>
                  <div class="error" v-if="firstTelnumberrequired || secondTelnumberrequired || lastTelnumberrequired">
                    필수 입력란입니다.
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">사업자주소<span class="redDot">*</span></th>
                <td colspan="3">
                  <div class="address">
                    <div class="flex">
                      <input type="text" title="우편번호 입력" v-model="zipcode" readonly />
                      <button type="button" class="btn gray" @click="daumPostcodeBtn">우편번호</button>
                    </div>
                    <div class="flex">
                      <input type="text" title="주소 입력" v-model="addr" readonly />
                      <input type="text" title="상세주소 입력" v-model="addrDetail" />
                    </div>
                    <div class="error" v-if="addrrequired">필수 입력란입니다.</div>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">웹 선불권 신청주차장<span class="redDot">*</span></th>
                <td>
                  <select class="middle" v-model="sectnId">
                    <option :key="i" :value="parking.SECTN_ID" v-for="(parking, i) in parkingList">
                      {{ parking.PARKING_NM }}
                    </option>
                  </select>
                  <div class="error" v-if="sectnIdrequired">필수 입력란입니다.</div>
                </td>
                <div v-if="isNamcheon">
                  <th scope="row">무료 웹 선불권 서비스</th>
                  <td>
                    <div class="radioGroup">
                      <p class="radio">
                        <input type="radio" id="radio-01" name="radio" class="hidden" />
                        <label for="radio-01">사용함</label>
                      </p>
                      <p class="radio">
                        <input type="radio" id="radio-02" name="radio" class="hidden" />
                        <label for="radio-02">미사용</label>
                      </p>
                    </div>
                  </td>
                </div>
              </tr>
              <tr>
                <th scope="row">사업자등록증</th>
                <td>
                  <div class="flex fileArea">
                    <p class="upload-name">{{ firstName }}</p>
                    <input type="file" class="hidden" id="file" ref="files" @change="changeFile" @click="resetFile" />
                    <label for="file" class="btn gray">파일첨부</label>
                  </div>
                  <p class="info">첨부파일 (최대용량:20M) *이미지 파일 (jpg, jpeg, gif, png, pdf)</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <!--//table mobile-->

        <!--btnArea-->
        <div class="btnArea">
          <button type="button" class="btn gray" @click="$router.push('/businessagreement')">취소</button>
          <button type="button" class="btn blue" @click="ApplyBtn">가입신청</button>
        </div>
        <!--//btnArea-->
      </div>
    </section>

    <zip-code-modal v-if="isZipcodeModal">
      <template #info> 우편번호 </template>
      <template #content>
        <article>
          <VueDaumPostcode @complete="searchedAddress" />
        </article>
      </template>
      <template #button>
        <button class="btn closeBtn" @click="CancleBtn"><span class="hidden">닫기</span></button>
      </template>
    </zip-code-modal>
  </main>
</template>

<script>
import axios from '../../../util/axios';
import { required, sameAs, helpers, minLength, maxLength } from 'vuelidate/lib/validators';
const passRegex = helpers.regex('passRegex', /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/);
const idRegex = helpers.regex('idRegex', /^(?!(?:[0-9]+)$)([a-zA-Z]|[0-9a-zA-Z]){4,20}$/);
import ZipCodeModal from '../../../components/PopupType1.vue';
import { VueDaumPostcode } from 'vue-daum-postcode';

export default {
  data() {
    return {
      isZipcodeModal: false,
      firstName: '파일명',
      eFiles: '',
      parkingList: [],

      usedCnt: -1,
      empNo: '',
      password: '',
      passwordCon: '',
      companyNm: '',
      CEONm: '',
      companyNumber: '',
      firstNumber: '',
      secondNumber: '',
      lastNumber: '',
      firstTelnumber: '',
      secondTelnumber: '',
      lastTelnumber: '',
      zipcode: '',
      addr: '',
      addrDetail: '',
      sectnId: '',
      openDt: '',

      isNamcheon: false,

      empNorequired: false,
      empNoidRegex: false,
      passwordrequired: false,
      passwordminLength: false,
      passwordmaxLength: false,
      passwordpassRegex: false,
      passwordConrequired: false,
      passwordConsameAsPassword: false,
      companyNmrequired: false,
      CEONmrequired: false,
      companyNumberrequired: false,
      openDtrequired: false,
      firstNumberrequired: false,
      secondNumberrequired: false,
      lastNumberrequired: false,
      addrrequired: false,
      sectnIdrequired: false,
      firstTelnumberrequired: false,
      secondTelnumberrequired: false,
      lastTelnumberrequired: false,
    };
  },

  components: {
    ZipCodeModal,
    VueDaumPostcode,
  },

  validations: {
    empNo: {
      required,
      idRegex: idRegex,
    },
    password: {
      required,
      minLength: minLength(8),
      maxLength: maxLength(20),
      passRegex: passRegex,
    },
    passwordCon: {
      required,
      sameAsPassword: sameAs('password'),
    },
    companyNm: {
      required,
    },
    CEONm: {
      required,
    },
    companyNumber: {
      required,
    },
    firstNumber: {
      required,
    },
    secondNumber: {
      required,
    },
    lastNumber: {
      required,
    },
    firstTelnumber: {
      required,
    },
    secondTelnumber: {
      required,
    },
    lastTelnumber: {
      required,
    },
    openDt: {
      required,
    },
    zipcode: {
      required,
    },
    addr: {
      required,
    },
    sectnId: {
      required,
    },
  },

  mounted() {
    this.getParkingList();
  },

  methods: {
    changeFile(e) {
			const file = e.target.files[0];
			
			if (file.size > 2000000) {
				alert('최대 20mb까지 업로드할 수 있습니다.');
				this.resetFile();
				return;
			}

			if (file['type'] === 'image/jpeg' || file['type'] === 'image/png' || file['type'] === 'image/gif' || file['type'] === 'image/jpg' || file['type'] === 'image/pdf' || file['type'] == 'application/pdf') {
				this.firstName = file.name;
				this.eFiles = file;
			}
		},

    resetFile() {
      this.$refs.files.value = '';
      this.eFiles = [];
    },

    CancleBtn() {
      this.isZipcodeModal = false;
    },

    daumPostcodeBtn() {
      this.isZipcodeModal = true;
    },

    searchedAddress(data) {
      this.zipcode = data.zonecode;
      if (data.userSelectedType === 'R') {
        this.addr = data.address;
      } else {
        this.addr = data.jibunAddress;
      }
      this.isZipcodeModal = false;
    },

    async getParkingList() {
      const res = await axios('get', '/api/parking/map.json');
      this.parkingList = res.data.parkingMapList;
    },

    resetUsedCnt() {
      this.usedCnt = -1;
    },

    async OverlapBtn() {
      if (this.$v.empNo.$invalid) {
        this.usedCnt = -2;
        return;
      }
      const res = await axios('get', '/api/member/idDplctCnfirmAjax.json', {
        checkId: this.empNo,
      });
      this.usedCnt = res.data.usedCnt;
    },

    idValidation() {
      if (this.usedCnt === -1) {
        alert('아이디 중복검사를 해주십시오.');
        return false;
      }
      if (this.usedCnt === 1) {
        alert('중복된 아이디입니다.');
        return false;
      }
      if (this.usedCnt === -2) {
        alert('조건에 부합하지 않는 아이디입니다.');
        return false;
      }
      return true;
    },

    async ApplyBtn() {
      if (this.$v.$invalid) {
        for (let i = 0; i < Object.keys(this.$v).length; i++) {
          if (Object.values(this.$v)[i] != (null || undefined)) {
            for (let j = 0; j < Object.keys(Object.keys(this.$v)[i]).length; j++) {
              if (Object.keys(Object.values(this.$v)[i])[j] != (null || undefined)) {
                if (!Object.keys(Object.values(this.$v)[i])[j].includes('$')) {
                  if (!Object.values(Object.values(this.$v)[i])[j]) {
                    this.$data[Object.keys(this.$v)[i] + Object.keys(Object.values(this.$v)[i])[j]] = true;
                  } else {
                    this.$data[Object.keys(this.$v)[i] + Object.keys(Object.values(this.$v)[i])[j]] = false;
                  }
                }
              }
            }
          }
        }
        return;
      }
      if (!this.idValidation()) return;

      let apiParams = new FormData();
      apiParams.append('empNo', this.empNo);
      apiParams.append('password', this.password);
      apiParams.append('passwordCon', this.passwordCon);
      apiParams.append('companyNm', this.companyNm);
      apiParams.append('openDt', this.openDt);
      apiParams.append('empNm', this.CEONm);
      apiParams.append('companyNo', this.companyNumber);
      apiParams.append('empMobile', this.firstNumber + this.secondNumber + this.lastNumber);
      apiParams.append('empTelNo', this.firstTelnumber + this.secondTelnumber + this.lastTelnumber);
      apiParams.append('zipcode', this.zipcode);
      apiParams.append('addr', this.addr);
      apiParams.append('addrDetail', this.addrDetail);
      if (this.eFiles !== '') {
        apiParams.append('files', this.eFiles);
      }
      await axios('post', '/api/member/mberSbscrb.json', apiParams);

      let parkingParams = new FormData();
      parkingParams.append('empEsntlId', 'new');
      parkingParams.append('memberId', this.empNo);
      parkingParams.append('sectnId', this.sectnId);
      await axios('post', '/api/member/insertParking.json', parkingParams);
      this.$router.push('/businesscompletion');
    },
  },
};
</script>
